import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { ContractDataFieldNameDto, ContractPriority, ContractRisk } from "../autogen/bff-api";

export const useTranslationTools = () => {
  const { t } = useTranslation();
  const getRiskTranslation = (risk: ContractRisk): React.ReactElement => <>{contractLevelLabel(risk, t)}</>;

  const getPriorityTranslation = (priority: ContractPriority): React.ReactElement => (
    <>{contractLevelLabel(priority, t)}</>
  );

  const getDataFieldTranslation = (name: ContractDataFieldNameDto): string => {
    switch (name) {
      case ContractDataFieldNameDto.AwardDate:
        return t("Award date");
      case ContractDataFieldNameDto.RenewalDate:
        return t("Renewal date");
      case ContractDataFieldNameDto.CounterpartyContactPerson:
        return t("Counterparty contact person");
      case ContractDataFieldNameDto.DeliveryTerms:
        return t("Delivery terms");
      case ContractDataFieldNameDto.EstimatedValue:
        return t("Estimated total value");
      case ContractDataFieldNameDto.EndDate:
        return t("End date");
      case ContractDataFieldNameDto.ExternalLink:
        return t("External system link");
      case ContractDataFieldNameDto.InternalReferenceNumber:
        return t("Internal reference number");
      case ContractDataFieldNameDto.LinkedContracts:
        return t("Linked contracts");
      case ContractDataFieldNameDto.OriginSourcingEvent:
        return t("Origin sourcing event");
      case ContractDataFieldNameDto.PaymentTermsInDays:
        return t("Payment terms in days");
      case ContractDataFieldNameDto.PricePerMonth:
        return t("Price per month");
      case ContractDataFieldNameDto.PricePerYear:
        return t("Price per year");
      case ContractDataFieldNameDto.Priority:
        return t("Priority");
      case ContractDataFieldNameDto.PurchasingPolicy:
        return t("Purchase policy");
      case ContractDataFieldNameDto.Risk:
        return t("Risk");
      case ContractDataFieldNameDto.StartDate:
        return t("Start date");
      case ContractDataFieldNameDto.TotalLiability:
        return t("Total liability");
      case ContractDataFieldNameDto.TotalPrice:
        return t("Total price");
      case ContractDataFieldNameDto.WarrantyExpirationDate:
        return t("Warranty expiration date");
      case ContractDataFieldNameDto.TerminationDate:
        return t("Termination date");
      case ContractDataFieldNameDto.IfrsValues:
        return t("IFRS values");
      case ContractDataFieldNameDto.InternalParties:
        return t("Internal parties");
      case ContractDataFieldNameDto.SupplierInfo:
        return t("Supplier info");
      case ContractDataFieldNameDto.SupplierCategory:
        return t("Supplier category");
      case ContractDataFieldNameDto.NoticePeriod:
        return t("Notice period");
      case ContractDataFieldNameDto.Options:
        return t("Contract options");
      case ContractDataFieldNameDto.Projects:
        return t("Projects");
    }
  };

  return {
    getRiskTranslation,
    getPriorityTranslation,
    getDataFieldTranslation,
  };
};

export const contractLevelLabel = (level: ContractRisk | ContractPriority, t: TFunction): string => {
  switch (level as ContractRisk) {
    case ContractRisk.VeryLow:
      return t("Very low");
    case ContractRisk.BelowAverage:
      return t("Below average");
    case ContractRisk.Average:
      return t("Average");
    case ContractRisk.AboveAverage:
      return t("Above average");
    case ContractRisk.VeryHigh:
      return t("Very high");
  }
};
